import React from 'react'
import Navbar from '../inc/Navbar'

import { Link } from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";
import HeadmistressSenior from "../images/Ms. Indrani Bhattacharyya.jpg";



function MsIndraniBhattacharyya() {
  return (
    <div>
            <Navbar />
            <br />
            <br />
              <div className="album py-1">
                <div className="container">
                    <h1> KRISHNAGAR PUBLIC SCHOOL </h1>
                </div>
            </div>

            <div className='cbscschoolnadia'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Headmistress (Senior) <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <ScrollToTop smooth top="100" color="darkgoldenrod" />
            <br />
            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 className="card-title mb-3"><b>Message from the Headmistress (Senior) </b></h1>
                        </div>
                        <div className="album py-0">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-3 mt-3">
                                        <div class="card">
                                            <img src={HeadmistressSenior} className="card-img-top" alt="HeadmistressSenior"/>
                                        </div>

                                    </div>
                                    <div className="col-md-9 mt-3">
                                        <p className='mb-2'>It is immensely important to choose the right school not only when our children are just starting out and depend heavily on the parents to determine the atmosphere that is suitable for them but also later in life when they much aware of their needs and choices. It is important that students feel comfortable in the ambiance of the school at the same time get the exposure and facilities they need to develop into effective 21st century citizens.</p>
                                        <p className='justify mb-2'>At Krishnagar Public School, Nadia, we believe that Education is a shared commitment between dedicated teachers, motivated students and enthusiastic parents with high expectations. We strive to provide each of our students the opportunity to express themselves through a carefully planned curriculum, and child-friendly pedagogy. We believe that each child has their own unique quality and as facilitators it is our responsibility to help identify, nurture and develop this potential in every learner in their formative years. Our dedicated and highly motivated team of teachers work tirelessly to ensure the very best opportunities for every child. We follow the CBSE curriculum and constantly update our methodology to incorporate the latest teaching techniques to ensure that it remains appropriate to the needs of our learners. State of the art infrastructure and modern practices ensure an effective teaching-learning process.</p>
                                        <p className='justify mb-2'>Being the only CBSE affiliated public school in the vicinity of Krishnagar, we offer a wide variety of subject combinations including Vocational or Skill Based subjects for the students to choose from according to their interests and skills. Our team of dedicated teachers are constantly updated with the latest innovations and educational policies implemented by the Board. </p>
                                        <p className='justify mb-2'>Our students are constantly trained to foster respect for diversity that prepares our students for participation in a complex and changing world. We strongly believe in the importance of parents, teachers and administrators working in unison, thereby ensuring happy and fruitful years of school education for all our students.</p>
                                        
                                        

                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />





                        <div className="d-flex justify-content-end align-items-end mb-0">
                            <div className='teamkps'>
                                <p className='mb-0'>Ms. Indrani Bhattacharyya
                                </p>
                                <h5><b>Headmistress (Senior)</b> </h5>
                            </div>

                        </div>
                    </div>
                </div>
            </div>



        </div>
  )
}

export default MsIndraniBhattacharyya